module.exports = __webpack_public_path__ + "img/chip-red.cca60936.png";